/* eslint-disable react/jsx-key */
import React from 'react'
import { strCol, dateCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import {
  modifierCol,
  modifiedDateCol,
  utilityHeader,
  unitHeader,
} from 'core/HeaderColTypeProps'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import { Input, Button, DatePicker } from 'antd'
import moment from 'moment'
import {
  getPnodeAndEmktMgmtInfo,
  postPnodeAndEmktMgmtInfo,
  deletePnodeAndEmktMgmtInfo,
} from 'api/pgads.js'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getUtilityUnitsMap,
} from 'core/selectors'

import CommonScreen from './CommonScreen'
import UtilityUnitSelection from '../../core/component/UtilityUnitSelection'

const requiredField = () => <span style={{ color: 'red' }}>*</span>

const retrieveTask = apiTargetInfo => getPnodeAndEmktMgmtInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postPnodeAndEmktMgmtInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deletePnodeAndEmktMgmtInfo(apiTargetInfo)(data)

const headers = [
  utilityHeader,
  unitHeader,
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
  }),
  strCol({
    ident: 'pnodeId',
    display: 'Pnode Id',
    isRequired: true,
  }),
  strCol({
    ident: 'emktId',
    display: 'eMarket Id',
    isRequired: true,
    ellipsis: true,
    width: 150,
  }),
  strCol({
    ident: 'rollupEmktId',
    display: 'Rollup eMarket Id',
    width: 250,
    ellipsis: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const title = 'Pnode and Emkt Id Management'

class PnodeAndEmktMgmt extends React.Component {
  state = { insertEvent: false }

  insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '10px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <td style={{ width: '70px', textAlign: 'right' }}>
              Unit{requiredField()} :
            </td>
            <td colSpan={3}>
              <UtilityUnitSelection
                className="utilityUnit"
                style={{ width: '100%' }}
                unit={insertData.unit}
                utility={insertData.utility}
                onUnitChange={value =>
                  setInsertData({
                    ...insertData,
                    utility: value[0],
                    unit: value[1],
                  })
                }
              />
            </td>

            <td style={{ textAlign: 'right' }}>Effective Date :</td>
            <td>
              <DatePicker
                style={{ width: '100%' }}
                allowClear
                format="MM/DD/YYYY"
                value={moment(insertData.effectiveDate)}
                onChange={d => {
                  setInsertData({
                    ...insertData,
                    effectiveDate: d.format('YYYY-MM-DD'),
                  })
                }}
              />
            </td>
          </tr>
          <tr>
            <td style={{ textAlign: 'right' }}>Pnode Id :</td>
            <td>
              <Input
                name="pnodeId"
                // style={{ width: '100px' }}
                value={insertData.pnodeId}
                onChange={e =>
                  setInsertData({ ...insertData, pnodeId: e.target.value })
                }
              />
            </td>
            <td style={{ textAlign: 'right' }}>eMarket Id : </td>
            <td>
              <Input
                name="eMarketId"
                // style={{ width: '100px' }}
                value={insertData.emktId}
                onChange={e =>
                  setInsertData({ ...insertData, emktId: e.target.value })
                }
              />
            </td>
            <td style={{ textAlign: 'right' }}> RollUp Market Id: </td>
            <td>
              <Input
                name="rollUpMarketId"
                // style={{ width: '100px' }}
                value={insertData.rollupEmktId}
                onChange={e =>
                  setInsertData({ ...insertData, rollupEmktId: e.target.value })
                }
              />
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  generateDataGetter = ({ rowData, header }) => {
    if (header.ident === 'unit') header.choices = []
    if (rowData.utility !== '' && rowData.utility !== undefined) {
      if (header.ident === 'unit') {
        const unitList =
          this.props.utilityUnitMap &&
          this.props.utilityUnitMap[rowData.utility]
        header.choices = unitList
          ? unitList.map(value => ({
              text: this.props.unitNameMap[value] || value,
              value,
            }))
          : []

        return rowData.unit
      }
    }
  }

  render() {
    const { utilityNameMap, unitNameMap } = this.props

    const headerWithFormatter = headers.map(header =>
      header.ident === 'utility'
        ? {
            ...header,
            ...toSelectionColProps(utilityNameMap),
            dataFormatter: ({ value }) => utilityNameMap[value] || value,
            sortIndexGetter: ({ rowData }) =>
              utilityNameMap[rowData.utility] || rowData.utility,
          }
        : header.ident === 'unit'
        ? {
            ...header,
            // ...toSelectionColProps(unitNameMap),
            choices: [],
            dataGetter: this.generateDataGetter,
            dataFormatter: ({ value }) => unitNameMap[value] || value,
            sortIndexGetter: ({ rowData }) =>
              unitNameMap[rowData.unit] || rowData.unit,
          }
        : header
    )

    return (
      <CommonScreen
        title={title}
        header={headerWithFormatter}
        saveTask={modifyTask}
        retrieveTask={retrieveTask}
        deleteTask={deleteTask}
        altBy={d => d.unit}
        autoRetrieve
        // sortOptions={[
        //   { ident: 'utility', display: 'Utility', sortOrder: 'asc' },
        //   { ident: 'unit', display: 'Unit', sortOrder: 'asc' },
        // ]}
        insertComp={this.state.insertEvent && this.insertComp}
        insertCompHeight={150}
        onInsertEvent={b => this.setState({ insertEvent: b })}
        defaultInsertData={{
          effectiveDate: moment().format('YYYY-MM-DD'),
          utility: null,
          unit: null,
        }}
        sortOptions={headers}
      />
    )
  }
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
})

export default connect(mapStateToProps)(PnodeAndEmktMgmt)
